import React from 'react';

export const CircleQuarterFull = (props: JSX.IntrinsicElements['svg']) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.986 14.981A6.501 6.501 0 0014.966 9h2.005a8.501 8.501 0 01-7.985 7.985v-2.004zm0-12.962a6.501 6.501 0 015.98 5.98h2.005A8.501 8.501 0 008.986.015V2.02zm-1-2.005A8.501 8.501 0 000 8h2.004a6.501 6.501 0 015.982-5.981V.014zm0 14.967v2.004A8.501 8.501 0 010 9h2.004a6.501 6.501 0 005.982 5.981z"
            fill="currentColor"
        />
    </svg>
);
